<template>
    <section class="staff">
        <el-button type="primary" @click="exportTable">导出表格</el-button>
    </section>
</template>

<script>
import { mapMutations } from 'vuex';
import { random } from '@/utils';

export default {
	name: 'staff',
	methods: {
		...mapMutations({
			addDownload: 'ADD_DOWNLOAD'
		}),
		exportTable() {
			console.log('export');
			let int = random(0, 100);
			this.addDownload({
				download: {
					type: 'excel',
					progress: int,
					status: 1,
					name: '十牛信息小学教师分析数据2018-11-15'
				}
			});
		}
	}
};
</script>
